import http from "../../utils/http";
import { toast } from "../../utils/toast";

// 기타 근무 목록
export const getWorkOtherList = (body) => {
  return new Promise((resolve, reject) => {
    http
      .post("/work/others/list", body)
      .then((res) => {
        resolve(res);
      })
      .catch((err) => {
        reject(err);
      });
  });
};

// 기타 근무 항목 등록
export const createWorkOthers = (body) => {
  return new Promise((resolve, reject) => {
    http
      .post("/work/others", body)
      .then((res) => {
        toast.success('기타근무가 등록되었습니다.')
        resolve(res);
      })
      .catch((err) => {
        reject(err);
      });
  });
};

// 기타 근무 항목 수정
export const modifyWorkOthers = (workIdx, body) => {
  return new Promise((resolve, reject) => {
    http
      .put(`/work/others/${workIdx}`, body)
      .then((res) => {
        toast.success('기타근무가 수정되었습니다.')
        resolve(res);
      })
      .catch((err) => {
        reject(err);
      });
  });
};

// 기타 근무 항목 삭제
export const deleteWorkOthers = (workIdx) => {
  return new Promise((resolve, reject) => {
    http
      .delete(`/work/others/${workIdx}`)
      .then((res) => {
        toast.success('기타근무가 삭제되었습니다.')
        resolve(res);
      })
      .catch((err) => {
        reject(err);
      });
  });
};

// 기타 근무 신청 등록
export const postRequestWorkOther = (params) => {
  return new Promise((resolve, reject) => {
    http
      .post("/work/request/other", params)
      .then((res) => {
        toast.success('기타근무 신청이 완료되었습니다.')
        resolve(res);
      })
      .catch((err) => {
        toast.error('기타근무 신청에 실패했습니다.')
        reject(err);
      });
  });
};